// port from @styled-system/flexbox v.5.1.2
import { system } from './system-core'

const config = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
}

export const flexbox = system(config)

export default flexbox
